interface IDriverDate {
  // null while the user is editing an empty cell in DriversetEditor.
  day: number | null;
  values: {
    // null when the user has cleared a cell in the editor, or when the data
    // legitimately has no value for that parameter on that day.
    [parameterName in TDriversetParameter]: number | null;
  };
  index?: number;
}

interface IDriverParameter {
  name: TDriversetParameter;
  label: string;
  unit: string;
}

type TDriversetParameter = 
  'waterTemperature' | 'salinity' | 'chlorophyll' | 'currentSpeed' |
  'dissolvedOxygen' | 'nitrogen' | 'pom' | 'tpm';

const DriverParameters: IDriverParameter[] = [
  { name: "waterTemperature", label: "Temperature", unit: "°C" },
  { name: "salinity", label: "Salinity", unit: "-" },
  { name: "chlorophyll", label: "Chlorophyll", unit: "ug L⁻¹" },
  { name: "currentSpeed", label: "Current speed", unit: "m s⁻¹" },
  { name: "dissolvedOxygen", label: "Dissolved oxygen", unit: "mg L⁻¹" },
  { name: "nitrogen", label: "Nitrogen", unit: "umol L⁻¹" },
  { name: "pom", label: "POM", unit: "mg L⁻¹" },
  { name: "tpm", label: "TPM", unit: "mg L⁻¹" },
] as const;

interface IDriverset {
  name: string;
  dates: IDriverDate[];
  // Set on per-area snapshots: `false` for unmodified copies of a system driver
  // set, `true` after the admin edits. Absent on system driver sets themselves.
  custom?: boolean;
}

/**
 * Strip the editor's transient `index` field from each date — it identifies
 * rows during in-memory editing and must not be persisted.
 */
const stripDateIndices = (ds: IDriverset): IDriverset => ({
  ...ds,
  dates: ds.dates.map(d => ({ day: d.day, values: { ...d.values } })),
});

export { IDriverset, IDriverParameter, IDriverDate, DriverParameters, TDriversetParameter, stripDateIndices }
